<script setup lang="ts">
import { useIdeStore } from '@/stores/ide.store'

import { IDEVIEWTABS, TAB_BUTTON_POSITION, TAB_ICONS_NAMES } from '@/utils/tabs'

import browserIcon from '@/assets/images/ide/browser.svg'
import TabCompTitleBar from '@/components/ide/ide/TabCompTitleBar.vue'
import HTMLOutputComp from '@/components/ide/ide/languages/html/OutputComp.vue'

const props = defineProps({
  tabPosition: {
    type: String,
    required: false,
    default: TAB_BUTTON_POSITION.BOTTOM
  }
})

const ideStore = useIdeStore()
</script>

<template>
  <div class="relative flex h-full w-full flex-col">
    <TabCompTitleBar
      v-if="ideStore.currentMobileTab == null && props.tabPosition == TAB_BUTTON_POSITION.MAXIMIZE"
      titleName="Browser"
      :icon="browserIcon"
      :tabPosition="props.tabPosition"
      :tabName="TAB_ICONS_NAMES.BROWSER"
    />

    <div
      class="background-quaternary relative h-full w-full overflow-auto"
      :id="`${IDEVIEWTABS.BROWSER}-main`"
    >
      <HTMLOutputComp v-if="ideStore.currentMobileTab == null" />
    </div>
  </div>
</template>
